import { Navigate } from "react-router-dom";
import { useAuth } from "../context/useAuth";

/**
 * Redirects guest users (not logged in) to the home page.
 * Use this to protect pages that require authentication but aren't admin-only.
 */
export function GuestRoute({ children }: { children: React.ReactNode }) {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) return null;

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
